<template>
  <el-dialog title="二维码" :visible.sync="dialogVisible" width="30%" @close="$emit('update:visible',false)">
    <div class="mb15 tcenter">
      <img class="mb15 qrtc" :src="property.qrcode" width="200" />
      <p class="mb20">{{property.name}}</p>
      <!-- <el-button type="primary" size="small" @click="onDownload">下载至本地</el-button> -->
    </div>
  </el-dialog>  
</template>

<script>
import api from "@/api.js";
export default {
  name: 'merchantQrcodeDialog2',
  props: ['visible', 'property'],
  data() {
    return {
      dialogVisible: false
    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  methods: {
    onDownload() {
      let _this = this;
      // 解决跨域 Canvas 污染问题
      let image = document.createElement('img');
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = "QrcodeImage"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = _this.property.base64;      
    }
  }
}
</script>